import React, { Component } from 'react'; //different
//import './style.css';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import { json } from 'react-router-dom';
import { LoopTwoTone } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: false, // Indicates in progress state of login form
            stateopterror: "",
            stateregis: 1,
            showpass: true,
            bankselect: 0,
            trueaccount: true,
            username: null,
            fname: "",
            checkboxacc: 0,
            userid: null,
            phoneNumber: "",
            userrecomend: "",
            linelink: "",
            balance: 0,
            mainacc: null,
        }
        this.forgetotpandregister = this.forgetotpandregister.bind(this);
    }

    notify = async (mode, msg) => {
        const type = String(mode || "").toLowerCase();

        if (type === "success") {
            toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored"
            });
        } else if (type === "warning") {
            toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored"
            });
        } else if (type === "error") {
            toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored"
            });
        } else {
            toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored"
            });
        }
    };

    safeHideError = (id, displayId) => {
        const el = document.getElementById(id);
        const displayEl = document.getElementById(displayId);

        if (el) el.style = "";
        if (displayEl) displayEl.style.display = "none";
    };

    onChangex = (event) => {
        if (!event || !event.target) return;

        const nam = event.target.name;
        const val = event.target.value;

        if (nam === "otpphone") {
            this.safeHideError("otpphone", "checkotp");
        } else if (nam === "phoneNumber") {
            this.safeHideError("phoneNumber", "checkotpforgetphonenormal");
            this.safeHideError("phoneNumberforget", "checkotpforgetphone");
        } else if (nam === "otpphoneforget") {
            this.safeHideError("otpphoneforget", "checkotpforget");
        }

        this.setState({
            [nam]: val
        });
    };

    radiocheck = (input) => {
        this.setState({
            bankselect: input
        });

        if (Number(input) === 99) {
            this.setState({
                trueaccount: false
            });
        } else {
            this.setState({
                trueaccount: true,
                fname: ""
            });
        }
    };
    renderDesktop = () => {
        const {
            phoneNumber,
            showpass,
            password,
            passwordcf,
            fname,
            trueaccount,
            tblbank,
            bankselect,
            accnumbertxt,
            userrecomend,
            loading
        } = this.state;

        return (
            <>
                <ToastContainer />
                <div className="standard-normal-font-size body-content-container" data-radium="true">
                    <article className="register-main-container">
                        <div className="registration-title">สมัครสมาชิก</div>

                        <div className="register">
                            <div className="reg">
                                <div className="register-container-header">ลงทะเบียนกับ</div>

                                <div className="_externalSocialContainer_5f4l2_1 ">
                                    <button className="_externalButton_5f4l2_13 atoms-button" title="ไลน์" type="button">
                                        <span>ไลน์</span>
                                    </button>

                                    <button className="_externalButton_5f4l2_13 atoms-button" title="เทเลแกรม" type="button">
                                        <span>เทเลแกรม</span>
                                    </button>

                                    <button className="_externalButton_5f4l2_13 atoms-button" title="Google" type="button">
                                        <span>Google</span>
                                    </button>

                                    <button className="_externalButton_5f4l2_13 atoms-button" title="วอทแอพ" type="button">
                                        <span>วอทแอพ</span>
                                    </button>
                                </div>

                                <div className="external-reg-break-line">
                                    <div className="break-line" />
                                    <span>หรือ</span>
                                    <div className="break-line" />
                                </div>

                                <div className="reg-container">
                                    <form
                                        className="standard-form-container"
                                        autoComplete="new-password"
                                        onSubmit={(e) => this.nextstep(e, 25)}
                                    >
                                        <div className="register-input-container">
                                            <div className="standard-form-field username-field">
                                                <label className="standard-label standard-mandatory standard-form-col-100">
                                                    ยูสเซอร์เนม
                                                </label>

                                                <div className="standard-form-field-wrapper">
                                                    <input
                                                        type="text"
                                                        id="phoneNumber"
                                                        name="phoneNumber"
                                                        className="standard-input standard-form-col-100"
                                                        placeholder=""
                                                        value={phoneNumber || ""}
                                                        maxLength={10}
                                                        onChange={this.onChangex}
                                                    />
                                                    <div className="stat-text-div" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="register-input-container">
                                            <div className="standard-form-field password-field">
                                                <label className="standard-label standard-mandatory standard-form-col-100">
                                                    รหัสผ่าน
                                                </label>

                                                <div className="standard-form-field-wrapper password-field">
                                                    <input
                                                        type={showpass ? "password" : "text"}
                                                        id="password"
                                                        name="password"
                                                        className="standard-input standard-form-col-100"
                                                        autoComplete="new-password"
                                                        placeholder=""
                                                        value={password || ""}
                                                        onChange={this.onChangex}
                                                    />

                                                    <svg
                                                        onClick={this.changepass}
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 1024 1024"
                                                        className="standard-password-eye"
                                                        width="1em"
                                                        height="1em"
                                                    >
                                                        <g className="AiOutlineEyeInvisible">
                                                            <path d="M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z" />
                                                        </g>
                                                    </svg>

                                                    <div className="stat-text-div" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="register-input-container">
                                            <div className="standard-form-field password-field">
                                                <label className="standard-label standard-mandatory standard-form-col-100">
                                                    ยืนยันรหัสผ่าน
                                                </label>

                                                <div className="standard-form-field-wrapper password-field">
                                                    <input
                                                        type={showpass ? "password" : "text"}
                                                        id="passwordcf"
                                                        name="passwordcf"
                                                        className="standard-input standard-form-col-100"
                                                        autoComplete="new-password"
                                                        placeholder=""
                                                        value={passwordcf || ""}
                                                        onChange={this.onChangex}
                                                    />

                                                    <div className="stat-text-div" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="register-input-container">
                                            <div className="standard-form-field phone-field">
                                                <label className="standard-label standard-mandatory standard-form-col-100">
                                                    เบอร์ติดต่อ
                                                </label>

                                                <div className="standard-m-form-col-full standard-form-col-100 phone-field">
                                                    <div
                                                        id="dropdownBtn"
                                                        className="standard-select standard-form-col-40 standard-m-form-col-50 standard-form-margin-right-5px standard-m-form-margin-right-10px"
                                                    >
                                                        <img
                                                            loading="lazy"
                                                            src="/build/web/igame-index-lobby-wm/img/TH.png"
                                                            alt=""
                                                        />
                                                        <span>+66</span>
                                                        <div className="standard-select-arrow" />
                                                    </div>

                                                    <div className="standard-form-field-wrapper">
                                                        <input
                                                            type="text"
                                                            name="phoneNumber"
                                                            className="standard-input standard-form-col-100"
                                                            placeholder=""
                                                            value={phoneNumber || ""}
                                                            maxLength={10}
                                                            onChange={this.onChangex}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="register-input-container">
                                            <div className="standard-form-field preferredCurrencyLabel-field">
                                                <label className="standard-label standard-mandatory standard-form-col-100">
                                                    ธนาคาร
                                                </label>

                                                <div className="register-bank-grid">
                                                    {Array.isArray(tblbank) && tblbank.length > 0 ? (
                                                        tblbank.map((listitem, i) => (
                                                            <button
                                                                key={`${listitem.bank_id}-${i}`}
                                                                type="button"
                                                                className={`register-bank-item ${bankselect === listitem.bank_id ? "active" : ""}`}
                                                                onClick={() => this.radiocheck(listitem.bank_id)}
                                                            >
                                                                <img
                                                                    className={bankselect === listitem.bank_id ? "imgBankNotSelect" : "imgBank"}
                                                                    src={listitem.img_path}
                                                                    alt={listitem.bank_name || "bank"}
                                                                />
                                                            </button>
                                                        ))
                                                    ) : (
                                                        <div className="register-bank-loading">
                                                            กำลังโหลดธนาคาร...
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="register-input-container">
                                            <div className="standard-form-field fullname-field">
                                                <label className="standard-label standard-mandatory standard-form-col-100">
                                                    เลขบัญชีธนาคาร
                                                </label>

                                                <div className="standard-form-field-wrapper">
                                                    <input
                                                        type="text"
                                                        id="accnumbertxt"
                                                        name="accnumbertxt"
                                                        className="standard-input standard-form-col-100"
                                                        placeholder=""
                                                        value={accnumbertxt || ""}
                                                        onChange={this.onChangex}
                                                    />
                                                    <div className="stat-text-div" />
                                                </div>
                                            </div>
                                        </div>

                                        {/* ชื่อ-นามสกุล — ย้ายมาไว้ใต้เลขบัญชี พร้อมพื้นหลังเทา */}
                                        <div className="register-input-container" style={{ background: '#f3f4f6', borderRadius: 8, padding: '12px 16px', marginBottom: 8 }}>
                                            <div className="standard-form-field fullname-field">
                                                <label className="standard-label standard-form-col-100" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                    ชื่อ-นามสกุล
                                                    <span
                                                        title="ไม่ต้องกรอกชื่อ ให้ใส่แค่เลขบัญชีธนาคาร ระบบจะตรวจสอบชื่อให้อัตโนมัติ"
                                                        style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 18, height: 18, borderRadius: '50%', background: '#6b7280', color: '#fff', fontSize: 11, fontWeight: 700, cursor: 'default', flexShrink: 0 }}
                                                    >?</span>
                                                </label>
                                                <div className="standard-form-field-wrapper">
                                                    <input
                                                        type="text"
                                                        id="fname"
                                                        name="fname"
                                                        className="standard-input standard-form-col-100"
                                                        placeholder="ชื่อบัญชีธนาคาร"
                                                        value={fname || ""}
                                                        onChange={this.onChangex}
                                                        disabled={trueaccount}
                                                    />
                                                </div>
                                                <div style={{ marginTop: 6, fontSize: 12, color: '#6b7280', display: 'flex', alignItems: 'center', gap: 4 }}>
                                                    <span>ℹ️</span>
                                                    <span>ไม่ต้องกรอก — ระบบจะตรวจสอบชื่อจากเลขบัญชีธนาคารให้อัตโนมัติ</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="register-input-container affiliateID">
                                            <div className="standard-form-field affiliateid-field ignore-after">
                                                <label className="standard-label standard-form-col-100">
                                                    ID พันธมิตร / รหัสแนะนำ
                                                </label>

                                                <div className="standard-form-field-wrapper aff-field">
                                                    <input
                                                        type="text"
                                                        name="userrecomend"
                                                        className="standard-input standard-form-col-100 afffield"
                                                        placeholder=""
                                                        value={userrecomend || ""}
                                                        onChange={this.onChangex}
                                                    />
                                                    <div className="stat-text-div" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="turnstile-container">
                                            <div>
                                                <input
                                                    type="hidden"
                                                    name="cf-turnstile-response"
                                                    id="cf-chl-widget-stkex_response"
                                                    value=""
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        <div className="transaction-button-section">
                                            <div className="standard-button-container reg-btn-container">
                                                <button
                                                    className="standard-submit-form-button"
                                                    disabled={loading}
                                                    data-button-category="submit"
                                                    type="submit"
                                                >
                                                    <span>
                                                        {loading ? "กำลังสมัครสมาชิก..." : "สมัครสมาชิก"}
                                                    </span>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="reg-footer-notice">
                                            ด้วยการคลิกที่ปุ่ม ลงทะเบียน, ข้าพเจ้าขอรับรองว่าข้าพเจ้ามีอายุเกิน 18 ปีและได้อ่านและยอมรับ
                                            <a href="/th-th/info-centre">ข้อกำหนดและเงื่อนไข</a>
                                            ของท่านแล้ว
                                        </div>

                                        <div className="prompt-login">
                                            มีบัญชีอยู่แล้วใช่หรือไม่? <a href="/th-th/login">ลงชื่อเข้าใช้</a>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <div className="right">
                                <div
                                    className="member-benefits-container"
                                    style={{
                                        color: "rgb(0, 0, 0)",
                                        position: "relative",
                                        padding: "0.37rem 0.31rem 0.52rem"
                                    }}
                                >
                                    <div className="member-benefits-row 0 sliderNavigation">
                                        <div className="reg-slider-container">
                                            <div className="slick-slider slider slick-initialized" dir="ltr">
                                                <div className="slick-list">
                                                    <div
                                                        className="slick-track"
                                                        style={{
                                                            opacity: 1,
                                                            transform: "translate3d(0px, 0px, 0px)",
                                                            width: "100%"
                                                        }}
                                                    >
                                                        <div
                                                            data-index={0}
                                                            className="slick-slide slick-active slick-current"
                                                            tabIndex={-1}
                                                            aria-hidden="false"
                                                            style={{ outline: "none", width: "100%" }}
                                                        >
                                                            <div>
                                                                <div className="image-container" style={{ height: "auto" }}>
                                                                    <span
                                                                        className="global-placeholder lazy-load-image-background lazy-load-image-loaded"
                                                                        style={{ color: "transparent", display: "inline-block" }}
                                                                    >
                                                                        <img
                                                                            loading="lazy"
                                                                            src="https://s3.newworld.center/image/95e1955d-036b-49e0-ad6b-f961c5ddc05b.webp"
                                                                            className="reg-banner-img"
                                                                            alt="banner"
                                                                            id="reg-banner-img-1"
                                                                            style={{
                                                                                width: "100%",
                                                                                borderRadius: "0.08rem",
                                                                                height: "3.36rem"
                                                                            }}
                                                                        />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className="dotsContainer"
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        marginTop: "0.33rem"
                                                    }}
                                                >
                                                    <button className="active" aria-label="slide 1 bullet" type="button" />
                                                    <button className="dots" aria-label="slide 2 bullet" type="button" />
                                                    <button className="dots" aria-label="slide 3 bullet" type="button" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="member-benefits-row 1" style={{ display: "flex", margin: "0.355rem 0px" }}>
                                        <div className="member-benefit-column-container">
                                            <div className="member-benefit-list-container">
                                                <div className="list-item">
                                                    <div className="pointer-item" style={{ fontSize: "0.18rem", color: "rgb(15, 22, 31)", margin: "20px 0px 10px" }}>
                                                        <div>โบนัสคุ้มครองรายสัปดาห์</div>
                                                    </div>
                                                </div>
                                                <div className="list-item">
                                                    <div className="pointer-item" style={{ fontSize: "0.12rem", color: "rgb(134, 151, 162)" }}>
                                                        <div>สูง 8,000 บาท</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="member-benefit-column-container">
                                            <div className="member-benefit-list-container">
                                                <div className="list-item">
                                                    <div className="pointer-item" style={{ fontSize: "0.18rem", color: "rgb(15, 22, 31)", margin: "20px 0px 10px" }}>
                                                        <div>สูง 1%</div>
                                                    </div>
                                                </div>
                                                <div className="list-item">
                                                    <div className="pointer-item" style={{ fontSize: "0.12rem", color: "rgb(134, 151, 162)" }}>
                                                        <div>โบนัสคุ้มครองรายสัปดาห์</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="member-benefit-column-container">
                                            <div className="member-benefit-list-container">
                                                <div className="list-item">
                                                    <div className="pointer-item" style={{ fontSize: "0.18rem", color: "rgb(15, 22, 31)", margin: "20px 0px 10px" }}>
                                                        <div>ฝากได้เลยตอนนี้!</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="member-benefits-row 2 custom" style={{ display: "flex" }}>
                                        <div className="member-benefit-column-container">
                                            <div
                                                className="member-benefit-list-container"
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginTop: "0.6rem"
                                                }}
                                            >
                                                <div className="list-item">
                                                    <div className="pointer-item">
                                                        <span
                                                            className="lazy-load-image-background opacity lazy-load-image-loaded"
                                                            style={{ color: "transparent", display: "inline-block" }}
                                                        >
                                                            <img
                                                                loading="lazy"
                                                                src="/build/web/igame-index-lobby-wm/img/icon-curacao.svg"
                                                                alt=""
                                                                style={{ width: "0.48rem", height: "0.38rem" }}
                                                            />
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="list-item">
                                                    <div
                                                        className="pointer-item"
                                                        style={{
                                                            fontSize: "0.12rem",
                                                            color: "rgb(134, 151, 162)",
                                                            marginLeft: 10,
                                                            textAlign: "left"
                                                        }}
                                                    >
                                                        <div>
                                                            ได้รับใบอนุญาตและอยู่ภายใต้การกำกับดูแลของรัฐบาลเกาะอิสระอันจูอัน สหภาพโคโมโรส
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                </div>

                <style>
                    {`
                    .register-bank-grid {
                        display: grid;
                        grid-template-columns: repeat(6, minmax(0, 1fr));
                        gap: 8px;
                        width: 100%;
                    }

                    .register-bank-item {
                        border: 1px solid rgba(0, 0, 0, .08);
                        background: #fff;
                        border-radius: 10px;
                        min-height: 46px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 6px;
                        cursor: pointer;
                        transition: all .18s ease;
                    }

                    .register-bank-item.active {
                        border-color: #0071e3;
                        box-shadow: 0 0 0 2px rgba(0, 113, 227, .16);
                    }

                    .register-bank-item img {
                        width: 32px;
                        height: 32px;
                        object-fit: contain;
                    }

                    .register-bank-loading {
                        grid-column: 1 / -1;
                        font-size: 13px;
                        color: #8697a2;
                        padding: 10px 0;
                    }

                    @media (max-width: 768px) {
                        .register-bank-grid {
                            grid-template-columns: repeat(4, minmax(0, 1fr));
                        }
                    }
                `}
                </style>


            </>
        );
    };

    renderMobile = () => {
        const {
            phoneNumber,
            showpass,
            password,
            passwordcf,
            fname,
            trueaccount,
            tblbank,
            bankselect,
            accnumbertxt,
            userrecomend,
            loading
        } = this.state;

        return (
            <>
                <ToastContainer />

                <div className="m-register-container">

                    <div className="_memberBenefitsSection_1ks1c_1 _m_memberBenefitsSection_1ks1c_18">
                        <section className="_bannerSection_1ks1c_7">
                            <div className="_authBannerSlidesContainer_1avrl_1 _m_authBannerSlidesContainer_1avrl_50">
                                <div className="slick-slider slick-initialized" dir="ltr">
                                    <div className="slick-list">
                                        <div
                                            className="slick-track"
                                            style={{
                                                opacity: "1",
                                                transform: "translate3d(-960px, 0px, 0px)",
                                                transition: "-webkit-transform 500ms",
                                                width: "3360px",
                                            }}>
                                            <div
                                                aria-hidden="true"
                                                className="slick-slide slick-cloned"
                                                data-index="-1"
                                                style={{
                                                    width: "480px",
                                                }}
                                                tabIndex="-1">
                                                <div>
                                                    <div
                                                        className="_authBannerItem_1avrl_1"
                                                        style={{
                                                            display: "inline-block",
                                                            width: "100%",
                                                        }}
                                                        tabIndex="-1">
                                                        <picture>
                                                            <source
                                                                srcSet="/build/web/igame-index-lobby-wm/img/videoImage20260512054633516_TH_TH.webp"
                                                                type="image/webp"
                                                            />
                                                            <img
                                                                alt="អ្នកឧបត្ថម្ភផ្លូវការនៃ"
                                                                className="_authBannerImg_1avrl_12"
                                                                effect="opacity"
                                                                src="/build/web/igame-index-lobby-wm/img/videoImage20260512054633516_TH_TH.jpg"
                                                            />
                                                        </picture>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                aria-hidden="true"
                                                className="slick-slide"
                                                data-index="0"
                                                style={{
                                                    outline: "none",
                                                    width: "480px",
                                                }}
                                                tabIndex="-1">
                                                <div>
                                                    <div
                                                        className="_authBannerItem_1avrl_1"
                                                        style={{
                                                            display: "inline-block",
                                                            width: "100%",
                                                        }}
                                                        tabIndex="-1">
                                                        <picture>
                                                            <source
                                                                srcSet="/build/web/igame-index-lobby-wm/img/videoImage20260512052118820_TH_TH.webp"
                                                                type="image/webp"
                                                            />
                                                            <img
                                                                alt="PK8 Gresini Racing MotoGP 2026-2028"
                                                                className="_authBannerImg_1avrl_12"
                                                                effect="opacity"
                                                                src="/build/web/igame-index-lobby-wm/img/videoImage20260512052118820_TH_TH.jpg"
                                                            />
                                                        </picture>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                aria-hidden="false"
                                                className="slick-slide slick-active slick-current"
                                                data-index="1"
                                                style={{
                                                    outline: "none",
                                                    width: "480px",
                                                }}
                                                tabIndex="-1">
                                                <div>
                                                    <div
                                                        className="_authBannerItem_1avrl_1"
                                                        style={{
                                                            display: "inline-block",
                                                            width: "100%",
                                                        }}
                                                        tabIndex="-1">
                                                        <picture>
                                                            <source
                                                                srcSet="/build/web/igame-index-lobby-wm/img/videoImage20260512053335094_TH_TH.png"
                                                                type="image/webp"
                                                            />
                                                            <img
                                                                alt="ผู้สนับสนุนหลักอย่างเป็นทางการ Burnley F.C."
                                                                className="_authBannerImg_1avrl_12"
                                                                effect="opacity"
                                                                src="/build/web/igame-index-lobby-wm/img/videoImage20260512053335094_TH_TH.png"
                                                            />
                                                        </picture>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                aria-hidden="true"
                                                className="slick-slide"
                                                data-index="2"
                                                style={{
                                                    outline: "none",
                                                    width: "480px",
                                                }}
                                                tabIndex="-1">
                                                <div>
                                                    <div
                                                        className="_authBannerItem_1avrl_1"
                                                        style={{
                                                            display: "inline-block",
                                                            width: "100%",
                                                        }}
                                                        tabIndex="-1">
                                                        <picture>
                                                            <source
                                                                srcSet="/build/web/igame-index-lobby-wm/img/videoImage20260512054633516_TH_TH.webp"
                                                                type="image/webp"
                                                            />
                                                            <img
                                                                alt="អ្នកឧបត្ថម្ភផ្លូវការនៃ"
                                                                className="_authBannerImg_1avrl_12"
                                                                effect="opacity"
                                                                src="/build/web/igame-index-lobby-wm/img/videoImage20260512054633516_TH_TH.jpg"
                                                            />
                                                        </picture>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                aria-hidden="true"
                                                className="slick-slide slick-cloned"
                                                data-index="3"
                                                style={{
                                                    width: "480px",
                                                }}
                                                tabIndex="-1">
                                                <div>
                                                    <div
                                                        className="_authBannerItem_1avrl_1"
                                                        style={{
                                                            display: "inline-block",
                                                            width: "100%",
                                                        }}
                                                        tabIndex="-1">
                                                        <picture>
                                                            <source
                                                                srcSet="/build/web/igame-index-lobby-wm/img/videoImage20260512052118820_TH_TH.webp"
                                                                type="image/webp"
                                                            />
                                                            <img
                                                                alt="PK8 Gresini Racing MotoGP 2026-2028"
                                                                className="_authBannerImg_1avrl_12"
                                                                effect="opacity"
                                                                src="/build/web/igame-index-lobby-wm/img/videoImage20260512052118820_TH_TH.jpg"
                                                            />
                                                        </picture>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                aria-hidden="true"
                                                className="slick-slide slick-cloned"
                                                data-index="4"
                                                style={{
                                                    width: "480px",
                                                }}
                                                tabIndex="-1">
                                                <div>
                                                    <div
                                                        className="_authBannerItem_1avrl_1"
                                                        style={{
                                                            display: "inline-block",
                                                            width: "100%",
                                                        }}
                                                        tabIndex="-1">
                                                        <picture>
                                                            <source
                                                                srcSet="/build/web/igame-index-lobby-wm/img/videoImage20260512053335094_TH_TH.webp"
                                                                type="image/webp"
                                                            />
                                                            <img
                                                                alt="ผู้สนับสนุนหลักอย่างเป็นทางการ Burnley F.C."
                                                                className="_authBannerImg_1avrl_12"
                                                                effect="opacity"
                                                                src="/build/web/igame-index-lobby-wm/img/videoImage20260512053335094_TH_TH.jpg"
                                                            />
                                                        </picture>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                aria-hidden="true"
                                                className="slick-slide slick-cloned"
                                                data-index="5"
                                                style={{
                                                    width: "480px",
                                                }}
                                                tabIndex="-1">
                                                <div>
                                                    <div
                                                        className="_authBannerItem_1avrl_1"
                                                        style={{
                                                            display: "inline-block",
                                                            width: "100%",
                                                        }}
                                                        tabIndex="-1">
                                                        <picture>
                                                            <source
                                                                srcSet="/build/web/igame-index-lobby-wm/img/videoImage20260512054633516_TH_TH.webp"
                                                                type="image/webp"
                                                            />
                                                            <img
                                                                alt="អ្នកឧបត្ថម្ភផ្លូវការនៃ"
                                                                className="_authBannerImg_1avrl_12"
                                                                effect="opacity"
                                                                src="/build/web/igame-index-lobby-wm/img/videoImage20260512054633516_TH_TH.jpg"
                                                            />
                                                        </picture>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="_authBannerDotsContainer_1avrl_18 u-flex u-justify-center">
                                        <button
                                            aria-label="slide 1 bullet"
                                            className="_dots_1avrl_22 "
                                            type="button"
                                        />
                                        <button
                                            aria-label="slide 2 bullet"
                                            className="_dots_1avrl_22 _dotActive_1avrl_28"
                                            type="button"
                                        />
                                        <button
                                            aria-label="slide 3 bullet"
                                            className="_dots_1avrl_22 "
                                            type="button"
                                        />
                                    </div>
                                </div>
                                <div className="_authBannerTitle_1avrl_31 u-flex u-justify-center">
                                    PK8 Gresini Racing MotoGP 2026-2028
                                </div>
                            </div>
                        </section>
                        <section className="_benefitHighlightsSection_1ks1c_10">
                            <div className="_benefitHighlightsContainer_p8fps_1 _m_benefitHighlightsContainer_p8fps_20 u-flex">
                                <div className="_benefitHighlightItem_p8fps_1 u-flex u-align-center  u-justify-center u-flex-column">
                                    <div className="_iconContainer_p8fps_4">
                                        <svg
                                            effect="opacity"
                                            viewBox="0 0 64.23024 55.41449"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <style
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        ".beta-fast-deposit .st0{fill:#E2E2E2;}   .beta-fast-deposit .st1{fill:#004A98;}   .beta-fast-deposit .st2{clip-path:url(#beta-fast-deposit-SVGID_2_);fill:#67E59E;}   .beta-fast-deposit .st3{fill:#67E59E;}   .beta-fast-deposit .st4{fill:#FFFFFF;}  ",
                                                }}
                                            />
                                            <g className="beta-fast-deposit">
                                                <g>
                                                    <g>
                                                        <path
                                                            className="st0"
                                                            d="M56.77762,31.04702c-0.37695,0-0.68359-0.30664-0.68359-0.68359s0.30664-0.68457,0.68359-0.68457h5.45996		c0.37695,0,0.68359,0.30762,0.68359,0.68457s-0.30664,0.68359-0.68359,0.68359H56.77762z"
                                                        />
                                                        <path
                                                            className="st0"
                                                            d="M23.9528,15.25764c-0.37646,0-0.68262-0.30664-0.68262-0.68359s0.30615-0.68359,0.68262-0.68359h4.81787		c0.37695,0,0.68311,0.30664,0.68311,0.68359s-0.30615,0.68359-0.68311,0.68359H23.9528z"
                                                        />
                                                        <path
                                                            className="st1"
                                                            d="M50.35135,42.07729c-1.43408,0-2.71973-0.55566-3.61963-1.56445		c-0.90918-1.01953-1.31885-2.37891-1.15283-3.8291l1.07422-9.38672c0.04932-0.43262,0.45605-0.79785,0.88818-0.79785		c0.18945,0,0.35693,0.07129,0.47168,0.2002c0.11621,0.13086,0.16846,0.30859,0.14648,0.5l-1.07373,9.38867		c-0.12207,1.06348,0.18311,2.06641,0.8584,2.82422c0.66992,0.75098,1.62012,1.16406,2.67578,1.16406		c2.14795,0,4.09424-1.74609,4.34033-3.89258l3.55371-31.06641c0.12109-1.06348-0.18359-2.06641-0.85938-2.82324		c-0.66992-0.75098-1.62012-1.16406-2.67676-1.16406c-2.14648,0-4.09326,1.74512-4.33838,3.8916l-0.38477,3.36523		c-0.0498,0.43164-0.45605,0.79785-0.88721,0.79785c-0.18945,0-0.35742-0.07129-0.47266-0.20117		c-0.1167-0.12988-0.16895-0.30859-0.14697-0.5l0.38525-3.36523c0.3457-3.02637,3.08887-5.48926,6.11426-5.48926		c1.43457,0,2.71973,0.55566,3.61914,1.56445c0.90918,1.01855,1.31836,2.37793,1.15234,3.82812l-3.55469,31.06543		C56.11942,39.6144,53.37626,42.07729,50.35135,42.07729z"
                                                        />
                                                        <g>
                                                            <defs>
                                                                <path
                                                                    d="M26.36198,27.27909c0,0,7.90102,0,10.32553,0s3.95614,1.14094,3.77667,2.70973				s-1.18373,2.78107-1.18373,2.78107s15.00527,1.49746,15.17657,0c0.17131-1.4975,3.74875-32.76961,3.74875-32.76961h-30.3774				L26.36198,27.27909z"
                                                                    id="beta-fast-deposit-SVGID_1_"
                                                                />
                                                            </defs>
                                                            <clipPath id="beta-fast-deposit-SVGID_2_">
                                                                <use
                                                                    style={{
                                                                        overflow: "visible",
                                                                    }}
                                                                    xlinkHref="#beta-fast-deposit-SVGID_1_"
                                                                />
                                                            </clipPath>
                                                            <path
                                                                className="st2"
                                                                d="M39.3637,31.12902c-3.58986,0-6.80622-1.39779-9.05587-3.93663			c-2.24771-2.53881-3.25934-5.91441-2.84853-9.50551c0.41067-3.58986,2.19461-6.96546,5.02334-9.50559			c2.83125-2.53943,6.36745-3.93787,9.95669-3.93787c3.5892,0,6.8054,1.39845,9.05503,3.93787			c2.24884,2.54013,3.26055,5.91573,2.84988,9.50559c-0.41081,3.5911-2.19484,6.9667-5.0247,9.50551			C46.49031,29.73123,42.95414,31.12902,39.3637,31.12902z"
                                                            />
                                                        </g>
                                                        <path className="st0" d="M54.27662,21.4449" />
                                                        <path
                                                            className="st1"
                                                            d="M5.22147,55.41323c-1.58154-0.00098-2.99072-0.64355-3.96777-1.80859		c-0.96826-1.15527-1.39844-2.69434-1.21143-4.33203l2.2207-19.33691c0.27734-2.41406,1.88965-4.63184,4.10742-5.65039		l15.61572-7.18359c0.03955-0.01953,0.07178-0.03223,0.10547-0.04297c0.42139-0.13477,0.84863-0.2041,1.2666-0.2041		c0.61914,0,1.19873,0.14648,1.72266,0.43457c0.91553,0.50098,1.53223,1.37012,1.73682,2.44922		c0.3833,2.01855-0.80859,4.2168-2.77148,5.1123l-1.99219,0.82129l-2.91157,1.14746h19.31587		c1.01514,0,1.93066,0.40039,2.57861,1.12598c0.69238,0.77637,1.00244,1.8252,0.87354,2.95313l-0.01465,0.13184		c-0.11475,1-0.57666,1.9707-1.30176,2.73242l-0.61719,0.64941l0.49316,0.67773c0.56445,0.77539,0.7998,1.8125,0.646,2.84766		c-0.33496,2.25781-2.33447,4.02734-4.55176,4.02734H23.64969l0.25391,1.2959c0.07813,0.4043,0.09326,0.82617,0.04443,1.25293		c-0.13379,1.17188-0.74707,2.2998-1.68213,3.09375l-0.67871,0.5752l0.40088,0.73438		c0.37549,0.68164,0.52295,1.48438,0.42725,2.32129c-0.26367,2.30273-2.27832,4.17578-4.4917,4.17578l0,0L5.22147,55.41323z		 M23.0828,18.38491c-0.19727,0-0.3999,0.02539-0.60156,0.07715l-0.09521,0.03125L6.80985,25.65053		c-1.62549,0.75-2.80762,2.39453-3.0127,4.18945l-2.2207,19.33398c-0.14453,1.25977,0.18848,2.44434,0.93701,3.33691		c0.74072,0.88477,1.79932,1.37207,2.98145,1.37207l12.70068,0.00098c1.32031,0,2.52539-1.14258,2.68652-2.54785		c0.08301-0.72559-0.12646-1.42969-0.57373-1.93066c-0.41309-0.46289-0.98682-0.7168-1.61572-0.7168		c-0.19287,0-0.36377-0.07227-0.48096-0.2041c-0.11865-0.13379-0.17188-0.31445-0.14941-0.51074		c0.05029-0.44141,0.46387-0.81348,0.90283-0.81348h0.76123c1.32031,0,2.52588-1.14355,2.68652-2.55078		c0.08301-0.72363-0.12549-1.42676-0.57275-1.92773c-0.4126-0.46191-0.98682-0.7168-1.61621-0.7168h-0.32813		c-0.19287,0-0.36377-0.07324-0.48096-0.2041c-0.11914-0.13379-0.17236-0.31543-0.1499-0.51172		c0.05078-0.44141,0.46387-0.81445,0.90283-0.81445h16.66846c1.31641,0,2.55078-1.09961,2.75146-2.45117		c0.11279-0.75195-0.0752-1.45898-0.5293-1.99023c-0.41309-0.48633-0.99805-0.75391-1.64697-0.75391H20.60477		c-0.19336,0-0.36426-0.07227-0.48145-0.2041c-0.11865-0.13281-0.17188-0.31445-0.14941-0.51074		c0.05176-0.45215,0.4751-0.84961,0.90527-0.85059h16.79248c1.32178,0,2.52783-1.14258,2.68896-2.54785l0.01465-0.13281		c0.08301-0.72363-0.12598-1.42676-0.57275-1.92773c-0.4126-0.46289-0.98682-0.7168-1.61621-0.7168H14.97244		c-0.34619,0-0.60693-0.23438-0.63477-0.56836c-0.03027-0.36816,0.22656-0.75488,0.59766-0.89941l8.34131-3.27148		c1.3877-0.44922,2.28223-1.9668,2.02051-3.33789c-0.13672-0.71484-0.54199-1.28809-1.1416-1.61426		C23.83084,18.47866,23.45926,18.38491,23.0828,18.38491z"
                                                        />
                                                        <path
                                                            className="st0"
                                                            d="M14.93338,9.58706c-0.37598,0-0.68213-0.30664-0.68213-0.68359s0.30615-0.68359,0.68213-0.68359h12.03027		c0.37695,0,0.68311,0.30664,0.68311,0.68359s-0.30615,0.68359-0.68311,0.68359H14.93338z"
                                                        />
                                                        <path
                                                            className="st0"
                                                            d="M28.66043,5.3019c-0.37646,0-0.68262-0.30664-0.68262-0.68359s0.30615-0.68359,0.68262-0.68359h6.53467		c0.37695,0,0.68311,0.30664,0.68311,0.68359S35.57206,5.3019,35.1951,5.3019H28.66043z"
                                                        />
                                                        <path className="st0" d="M29.53225,12.21206" />
                                                        <path
                                                            className="st0"
                                                            d="M22.87528,5.3019c-0.37646,0-0.68262-0.30664-0.68262-0.68359s0.30615-0.68359,0.68262-0.68359h2.24658		c0.37695,0,0.68311,0.30664,0.68311,0.68359S25.49881,5.3019,25.12186,5.3019H22.87528z"
                                                        />
                                                        <path
                                                            className="st3"
                                                            d="M39.06278,51.76088c-0.37646,0-0.68262-0.30664-0.68262-0.68359s0.30615-0.68359,0.68262-0.68359h12.02979		c0.37695,0,0.68359,0.30664,0.68359,0.68359s-0.30664,0.68359-0.68359,0.68359H39.06278z"
                                                        />
                                                        <path
                                                            className="st3"
                                                            d="M31.23319,55.17788c-0.37598,0-0.68213-0.30664-0.68213-0.68359s0.30615-0.68359,0.68213-0.68359h5.46094		c0.37695,0,0.68311,0.30664,0.68311,0.68359s-0.30615,0.68359-0.68311,0.68359H31.23319z"
                                                        />
                                                        <path
                                                            className="st3"
                                                            d="M33.18778,48.36831c-0.37646,0-0.68262-0.30664-0.68262-0.68359s0.30615-0.68359,0.68262-0.68359h2.67529		c0.37695,0,0.68311,0.30664,0.68311,0.68359s-0.30615,0.68359-0.68311,0.68359H33.18778z"
                                                        />
                                                        <path
                                                            className="st3"
                                                            d="M39.15165,48.36831c-0.37646,0-0.68262-0.30664-0.68262-0.68359s0.30615-0.68359,0.68262-0.68359h4.81787		c0.37695,0,0.68311,0.30664,0.68311,0.68359s-0.30615,0.68359-0.68311,0.68359H39.15165z"
                                                        />
                                                        <path
                                                            className="st3"
                                                            d="M27.47342,55.21206c-0.39551,0-0.71729-0.32227-0.71729-0.71777s0.32178-0.71777,0.71729-0.71777		c0.396,0,0.71777,0.32227,0.71777,0.71777S27.86942,55.21206,27.47342,55.21206z"
                                                        />
                                                        <path
                                                            className="st0"
                                                            d="M49.01346,26.63002c-0.37646,0-0.68262-0.30664-0.68262-0.68359s0.30615-0.68359,0.68262-0.68359h12.02979		c0.37695,0,0.68359,0.30664,0.68359,0.68359s-0.30664,0.68359-0.68359,0.68359H49.01346z"
                                                        />
                                                        <path
                                                            className="st0"
                                                            d="M60.92899,23.23745c-0.37695,0-0.68359-0.30762-0.68359-0.68457s0.30664-0.68359,0.68359-0.68359h2.61816		c0.37695,0,0.68359,0.30664,0.68359,0.68359s-0.30664,0.68457-0.68359,0.68457H60.92899z"
                                                        />
                                                        <path
                                                            className="st4"
                                                            d="M44.70559,17.28502c-0.50464-0.54353-1.28764-1.00529-2.31918-1.39347l0.66429-4.30284		c0.64563,0.16204,1.23681,0.67452,1.4876,0.77702c0.28244,0.11548,0.68076-0.0174,0.87665-0.20981		c0.15687-0.15415,0.58212-0.73059-0.05299-1.17483c-0.48787-0.42899-1.19185-0.70704-2.08607-0.85101l0.15278-0.98964		c0.06371-0.41266-0.2206-0.74825-0.6338-0.74825s-0.80113,0.33559-0.86484,0.74825l-0.14783,0.95752		c-1.24827,0.13595-3.5184,1.02148-3.89169,3.43938c-0.36692,2.37668,1.79933,3.37916,2.78568,3.72465l-0.81412,5.27334		c-0.67527-0.06971-1.36031-0.34174-2.05622-0.84325c-0.16644-0.10062-0.82733-0.3198-1.24273,0.24005		c-0.2404,0.32381-0.21208,0.88099,0.09921,1.12505c0.32421,0.25049,0.93607,0.5264,1.49557,0.70195		c0.47494,0.14612,0.9157,0.26828,1.46565,0.32114l-0.13617,0.88206c-0.06379,0.4132,0.22044,0.74932,0.63364,0.74932		s0.80121-0.33612,0.865-0.74932l0.15619-1.01171c0.61045-0.13795,1.16831-0.39072,1.65243-0.68068		c0.62658-0.36288,1.1483-0.82318,1.56625-1.38089c0.43938-0.61337,0.75697-1.25431,0.88927-1.92575		C45.56075,18.38705,44.97073,17.59224,44.70559,17.28502z M39.71561,13.46134c0.10232-0.54486,0.35452-0.98589,0.75571-1.32415		c0.33645-0.26387,0.69889-0.41614,1.07497-0.51114l-0.569,3.68558C40.03252,14.87113,39.59212,14.26124,39.71561,13.46134z		 M41.3905,22.34239l0.69778-4.51974c0.71598,0.31605,1.54567,0.86373,1.37183,1.98971		C43.25717,21.12688,42.39272,21.9407,41.3905,22.34239z"
                                                        />
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="_desc_p8fps_10">โบนัสคุ้มครองรายสัปดาห์</div>
                                    <div className="_subDesc_p8fps_15">สูง 8,000 บาท</div>
                                </div>
                                <div className="_benefitHighlightItem_p8fps_1 u-flex u-align-center  u-justify-center u-flex-column">
                                    <div className="_iconContainer_p8fps_4">
                                        <svg
                                            effect="opacity"
                                            viewBox="0 0 25.28221 24.30425"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <style
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        ".beta-promo-cash-rebate .st0{fill: url(#beta-promo-cash-rebate-SVGID_1_)}   .beta-promo-cash-rebate .st1{fill: url(#beta-promo-cash-rebate-SVGID_2_)}   .beta-promo-cash-rebate .st2{fill: url(#beta-promo-cash-rebate-SVGID_3_)}   .beta-promo-cash-rebate .st3{fill: url(#beta-promo-cash-rebate-SVGID_4_)}  ",
                                                }}
                                            />
                                            <g className="beta-promo-cash-rebate">
                                                <g>
                                                    <g>
                                                        <g>
                                                            <linearGradient
                                                                gradientUnits="userSpaceOnUse"
                                                                id="beta-promo-cash-rebate-SVGID_1_"
                                                                x1="25.40967"
                                                                x2="0.06924"
                                                                y1="11.06432"
                                                                y2="13.42602">
                                                                <stop
                                                                    offset="0"
                                                                    style={{
                                                                        stopColor: "rgb(4, 169, 194)",
                                                                    }}
                                                                />
                                                                <stop
                                                                    offset="1"
                                                                    style={{
                                                                        stopColor: "rgb(9, 94, 189)",
                                                                    }}
                                                                />
                                                            </linearGradient>
                                                            <path
                                                                className="st0"
                                                                d="M16.31564,6.53504c-0.0368-0.13901-0.12521-0.25553-0.25042-0.3281    c-0.08126-0.046-0.17325-0.07053-0.26626-0.07053c-0.19114,0-0.36899,0.10221-0.46456,0.26677l-6.46851,11.18    c-0.07104,0.1247-0.09046,0.26882-0.05366,0.40578c0.03782,0.13901,0.12674,0.25451,0.24786,0.32401    c0.08075,0.04804,0.17376,0.07359,0.26984,0.07359c0.19011,0,0.36796-0.10221,0.46404-0.26677l6.46851-11.18    C16.33353,6.8151,16.35244,6.67098,16.31564,6.53504z"
                                                            />
                                                            <linearGradient
                                                                gradientUnits="userSpaceOnUse"
                                                                id="beta-promo-cash-rebate-SVGID_2_"
                                                                x1="25.08905"
                                                                x2="-0.25137"
                                                                y1="7.62416"
                                                                y2="9.98586">
                                                                <stop
                                                                    offset="0"
                                                                    style={{
                                                                        stopColor: "rgb(4, 169, 194)",
                                                                    }}
                                                                />
                                                                <stop
                                                                    offset="1"
                                                                    style={{
                                                                        stopColor: "rgb(9, 94, 189)",
                                                                    }}
                                                                />
                                                            </linearGradient>
                                                            <path
                                                                className="st1"
                                                                d="M11.93635,9.09955c0-1.4739-1.19895-2.67286-2.67235-2.67286S6.59166,7.62565,6.59166,9.09955    c0,1.47288,1.19895,2.67183,2.67234,2.67183S11.93635,10.57243,11.93635,9.09955z M9.264,7.58578    c0.83457,0,1.51326,0.67869,1.51326,1.51377c0,0.83405-0.67869,1.51274-1.51326,1.51274    c-0.83456,0-1.51377-0.67869-1.51377-1.51274C7.75024,8.26448,8.42944,7.58578,9.264,7.58578z"
                                                            />
                                                            <linearGradient
                                                                gradientUnits="userSpaceOnUse"
                                                                id="beta-promo-cash-rebate-SVGID_3_"
                                                                x1="25.73023"
                                                                x2="0.38981"
                                                                y1="14.50385"
                                                                y2="16.86555">
                                                                <stop
                                                                    offset="0"
                                                                    style={{
                                                                        stopColor: "rgb(4, 169, 194)",
                                                                    }}
                                                                />
                                                                <stop
                                                                    offset="1"
                                                                    style={{
                                                                        stopColor: "rgb(9, 94, 189)",
                                                                    }}
                                                                />
                                                            </linearGradient>
                                                            <path
                                                                className="st2"
                                                                d="M15.86335,12.7516c-1.47339,0-2.67183,1.19895-2.67183,2.67183s1.19844,2.67183,2.67183,2.67183    s2.67234-1.19895,2.67234-2.67183S17.33674,12.7516,15.86335,12.7516z M15.86335,16.9372    c-0.83457,0-1.51326-0.67869-1.51326-1.51377s0.67869-1.51377,1.51326-1.51377c0.83456,0,1.51326,0.67869,1.51326,1.51377    S16.69791,16.9372,15.86335,16.9372z"
                                                            />
                                                        </g>
                                                        <linearGradient
                                                            gradientUnits="userSpaceOnUse"
                                                            id="beta-promo-cash-rebate-SVGID_4_"
                                                            x1="25.40022"
                                                            x2="0.05979"
                                                            y1="10.9629"
                                                            y2="13.3246">
                                                            <stop
                                                                offset="0"
                                                                style={{
                                                                    stopColor: "rgb(4, 169, 194)",
                                                                }}
                                                            />
                                                            <stop
                                                                offset="1"
                                                                style={{
                                                                    stopColor: "rgb(9, 94, 189)",
                                                                }}
                                                            />
                                                        </linearGradient>
                                                        <path
                                                            className="st3"
                                                            d="M15.70799,24.30365c-0.54939,0-1.09674-0.13696-1.62671-0.26984  c-0.53202-0.13288-1.00884-0.25246-1.44017-0.25246c-0.43491,0-0.90816,0.11857-1.40849,0.24531   c-0.54121,0.13492-1.10083,0.27597-1.6584,0.27597c-0.30408,0-0.57903-0.04089-0.84019-0.12572   c-0.86114-0.27904-1.45295-0.99248-1.97526-1.62211c-0.3235-0.39147-0.62452-0.75535-0.95415-0.99351   c-0.32708-0.23918-0.75944-0.41294-1.21786-0.59692c-0.7855-0.31481-1.6492-0.66131-2.17253-1.38089   c-0.52128-0.71651-0.58363-1.63233-0.63832-2.43981c-0.03424-0.51106-0.06593-0.99453-0.19778-1.39827   c-0.12214-0.37614-0.37154-0.76864-0.63525-1.18362c-0.44207-0.69709-0.94342-1.48617-0.94342-2.41017   s0.50033-1.71308,0.94189-2.40813c0.26422-0.416,0.51413-0.8085,0.63678-1.18669c0.13134-0.40476,0.16354-0.88414,0.19778-1.39213   C1.8306,6.35412,1.89295,5.43626,2.41424,4.71975c0.52537-0.72162,1.3814-1.06403,2.13675-1.36658   C5.02781,3.16305,5.47243,2.9852,5.80564,2.74194c0.32759-0.23918,0.63985-0.61532,0.94138-0.9792   C7.2775,1.12391,7.87187,0.40638,8.73403,0.12632C8.9957,0.04148,9.27065,0.0006,9.57422,0.0006   c0.55501,0,1.109,0.13901,1.6446,0.27291c0.50902,0.12879,0.98533,0.24838,1.42229,0.24838   c0.43389,0,0.90765-0.11857,1.40849-0.24531c0.5407-0.13492,1.09929-0.27597,1.6584-0.27597   c0.30459,0,0.57903,0.04088,0.83968,0.12572c0.86318,0.27904,1.45448,0.99248,1.97628,1.62313   c0.32708,0.39454,0.62861,0.75739,0.95364,0.99248c0.33679,0.24633,0.77937,0.42214,1.24801,0.60919   c0.75944,0.30357,1.61751,0.647,2.14237,1.36862c0.5223,0.71753,0.58414,1.63438,0.63832,2.4439   c0.03475,0.51004,0.06746,0.99044,0.19778,1.39316c0.12265,0.37819,0.37205,0.76966,0.63627,1.18464   c0.4436,0.7022,0.9424,1.49128,0.9424,2.41017c0,0.92093-0.4988,1.70899-0.93831,2.40301   c-0.26677,0.41907-0.51719,0.81259-0.64036,1.1918c-0.13083,0.40374-0.16303,0.88312-0.19727,1.39009   c-0.05622,0.81668-0.11908,1.73352-0.63883,2.44697c-0.52537,0.72162-1.3814,1.06403-2.13675,1.36658   c-0.47171,0.18807-0.91685,0.3649-1.25415,0.61123c-0.32606,0.23611-0.62401,0.5959-0.93933,0.97613   c-0.53151,0.64189-1.12638,1.35942-1.99008,1.63949C16.28753,24.26175,16.01258,24.30365,15.70799,24.30365z M12.6411,22.56809   c0.58721,0,1.155,0.1431,1.70439,0.28108c0.49164,0.12368,0.95569,0.2402,1.36249,0.2402   c0.17529,0,0.32759-0.02146,0.46558-0.06644c0.52793-0.1707,0.9608-0.693,1.41922-1.24597   c0.3603-0.4344,0.72469-0.87289,1.17033-1.19793c0.45638-0.33117,0.98686-0.54377,1.50048-0.74819   c0.67051-0.2678,1.30423-0.52128,1.62416-0.96182c0.31481-0.43236,0.35979-1.09981,0.40783-1.80712   c0.03833-0.56319,0.07768-1.14478,0.25451-1.68957c0.16967-0.52128,0.47069-0.99657,0.7625-1.45653   c0.39198-0.61839,0.75637-1.19384,0.75637-1.76419c0-0.56932-0.36337-1.14274-0.74768-1.74988   c-0.29693-0.46813-0.60101-0.94649-0.77119-1.46982c-0.17581-0.54275-0.21516-1.11923-0.25298-1.67628   c-0.04855-0.71447-0.09404-1.38805-0.40936-1.8204c-0.31993-0.44054-0.94444-0.68993-1.60525-0.95466   c-0.5218-0.20749-1.06045-0.42316-1.52041-0.75637c-0.44769-0.32708-0.81157-0.76557-1.16369-1.18975   c-0.46609-0.56217-0.89742-1.08243-1.42484-1.25415c-0.13799-0.04497-0.29028-0.06644-0.46558-0.06644   c-0.39965,0-0.85194,0.11243-1.33081,0.23202c-0.57597,0.14514-1.1504,0.29028-1.73608,0.29028   c-0.58517,0-1.15245-0.1431-1.70133-0.28108c-0.50851-0.12674-0.96642-0.24122-1.36556-0.24122   c-0.17581,0-0.3281,0.02146-0.46558,0.06644C8.57969,1.45202,8.14733,1.97432,7.68942,2.52627   C7.33372,2.95658,6.96882,3.39712,6.5196,3.7242C6.0668,4.05332,5.5358,4.26592,5.02219,4.47239   C4.34452,4.74223,3.71438,4.99368,3.39496,5.43421c-0.31481,0.43236-0.3603,1.09981-0.40885,1.80712   c-0.03833,0.56421-0.07768,1.14785-0.254,1.69059c-0.16967,0.52128-0.46967,0.99453-0.75995,1.45244   c-0.39198,0.61736-0.75893,1.19486-0.75893,1.76725c0,0.57137,0.36439,1.14682,0.75075,1.75601   c0.29437,0.46302,0.59896,0.9424,0.76813,1.4647c0.17581,0.53968,0.21516,1.11411,0.25349,1.66913   c0.04804,0.7206,0.0925,1.39213,0.40936,1.82756c0.32095,0.44156,0.947,0.69096,1.60934,0.95569   c0.52282,0.20954,1.06045,0.42418,1.5153,0.75433c0.44718,0.32606,0.80799,0.76148,1.15756,1.18158   c0.46813,0.56626,0.90203,1.09163,1.432,1.26233c0.13441,0.04497,0.28722,0.06644,0.46507,0.06644   c0.40732,0,0.86574-0.11448,1.35023-0.23713C11.48457,22.71221,12.05747,22.56809,12.6411,22.56809z"
                                                        />
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="_desc_p8fps_10">สูง 1%</div>
                                    <div className="_subDesc_p8fps_15">โบนัสคุ้มครองรายสัปดาห์</div>
                                </div>
                                <div className="_benefitHighlightItem_p8fps_1 u-flex u-align-center  u-justify-center u-flex-column">
                                    <div className="_iconContainer_p8fps_4">
                                        <svg
                                            effect="opacity"
                                            viewBox="0 0 27.66331 26.86677"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <style
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        ".beta-sponsors-weekly-rescue-bonus .st0{fill: #FF6C00}   .beta-sponsors-weekly-rescue-bonus .st1{fill: url(#beta-sponsors-weekly-rescue-bonus-SVGID_1_)}  ",
                                                }}
                                            />
                                            <g className="beta-sponsors-weekly-rescue-bonus">
                                                <g>
                                                    <g>
                                                        <path
                                                            className="st0"
                                                            d="M16.40348,25.57184c-0.32001-0.02258-0.56201-0.30137-0.53943-0.62135   c0.02258-0.32002,0.30134-0.56202,0.62135-0.53943c5.14566,0.36313,9.62745-3.5278,9.99058-8.67346   c0.13545-1.91938-0.31247-3.80405-1.29548-5.45028c-0.07963-0.1329-0.10315-0.28926-0.06508-0.43993   c0.03773-0.15104,0.13235-0.27808,0.26594-0.35802c0.10318-0.06145,0.22025-0.08906,0.33882-0.08069   c0.18896,0.01333,0.36065,0.11822,0.45852,0.28051c1.10661,1.85193,1.61041,3.97146,1.45806,6.13033   C27.22846,21.60521,22.18917,25.98014,16.40348,25.57184z"
                                                        />
                                                        <path
                                                            className="st0"
                                                            d="M14.84259,13.76396c-1.18986-0.0296-2.08464-0.66912-2.08464-1.21988   c0-0.27534,0.24614-0.68803,0.55073-0.68803c0.37326,0,0.66873,0.63874,1.53391,0.73736v-1.95724   c-0.89478-0.33454-1.90791-0.7184-1.90791-1.97693c0-1.24866,0.92477-1.78956,1.90791-1.91704V6.46685   c0-0.12821,0.14717-0.24656,0.33458-0.24656c0.1669,0,0.33454,0.11835,0.33454,0.24656v0.25488   c0.63913,0.01973,1.68147,0.20636,1.68147,0.7776c0,0.22528-0.15742,0.6782-0.52117,0.6782   c-0.27538,0-0.50144-0.31485-1.1603-0.36413v1.73115c0.87544,0.32467,1.85823,0.76696,1.85823,2.10441   c0,1.20998-0.75674,1.90791-1.85823,2.08542v0.30498c0,0.12744-0.16764,0.24579-0.33454,0.24579   c-0.18663,0-0.33458-0.11835-0.33458-0.24579V13.76396z M14.92152,9.32834v-1.4854   c-0.49196,0.07893-0.78669,0.31485-0.78669,0.68885C14.13483,8.96421,14.46937,9.15158,14.92152,9.32834 M15.43282,10.87212   v1.71142c0.43277-0.08875,0.73775-0.3444,0.73775-0.80642C16.17057,11.29467,15.85572,11.05949,15.43282,10.87212"
                                                        />
                                                        <path
                                                            className="st0"
                                                            d="M25.1306,7.31507c-0.24084-0.73987-0.86749-1.26868-1.63556-1.38043l-4.57019-0.6637l-2.04358-4.14087   c-0.34418-0.69702-1.04071-1.13-1.81781-1.13c-0.77655,0-1.47278,0.43353-1.81665,1.1311l-2.04358,4.13977l-4.56995,0.6637   C5.86497,6.0464,5.23747,6.57521,4.99577,7.31446C4.75627,8.05543,4.95359,8.85182,5.51036,9.3921l3.30597,3.22339l-0.5636,3.29272   c0.39618,0.23621,0.79376,0.53589,1.02618,0.89014l0,0l0.78583-4.58887L6.3209,8.56019   C6.08305,8.32887,5.9987,7.98915,6.10087,7.67347c0.10333-0.31555,0.37103-0.54089,0.69897-0.5885l5.17499-0.75195l2.31403-4.68774   c0.14716-0.29816,0.44391-0.48279,0.7746-0.48279c0.33154,0,0.62885,0.18463,0.776,0.48224l2.31403,4.68829l5.17499,0.75195   c0.32739,0.04761,0.5946,0.27344,0.69763,0.59009c0.10272,0.3147,0.01886,0.65381-0.21899,0.88513l-3.74487,3.64929   l0.88531,5.15357c0.04272,0.25317-0.02545,0.50854-0.18744,0.70032c-0.16602,0.19617-0.41016,0.3092-0.66968,0.3092   c-0.13861,0-0.27618-0.03406-0.39807-0.09814l-4.62891-2.43262l-4.6261,2.43152c-0.09918,0.05212-0.21075,0.06873-0.32147,0.07971   c0.22461,0.38867,0.48206,0.73889,0.81812,0.96655c0.01355-0.00684,0.02863-0.00903,0.04205-0.01599l4.0874-2.1488l4.08881,2.1488   c0.29291,0.15344,0.61896,0.2345,0.94287,0.2345c0.5965,0,1.1626-0.26416,1.55334-0.7251   c0.38281-0.45532,0.54474-1.05481,0.44421-1.64563l-0.7818-4.55188l3.30676-3.2229   C25.17582,8.8506,25.3723,8.05445,25.1306,7.31507z"
                                                        />
                                                        <linearGradient
                                                            gradientUnits="userSpaceOnUse"
                                                            id="beta-sponsors-weekly-rescue-bonus-SVGID_1_"
                                                            x1="19.79275"
                                                            x2="-0.00006"
                                                            y1="20.79197"
                                                            y2="20.79197">
                                                            <stop
                                                                offset="0"
                                                                style={{
                                                                    stopColor: "rgb(4, 169, 194)",
                                                                }}
                                                            />
                                                            <stop
                                                                offset="1"
                                                                style={{
                                                                    stopColor: "rgb(9, 94, 189)",
                                                                }}
                                                            />
                                                        </linearGradient>
                                                        <path
                                                            className="st1"
                                                            d="M19.63229,21.75233c-0.37659-0.83594-1.35782-1.37582-2.36477-0.99372l-2.5001,0.94887   c0.12356-0.78375-0.26701-1.59103-1.01504-1.95987l-2.91717-1.43874c-0.22141-0.10882-0.25374-0.23022-0.49209-0.71601   c-0.83556-2.00108-3.03998-3.08267-5.13555-2.51703l-1.53803,0.41519c-0.35598-0.49281-0.91572-0.77673-1.51958-0.77378   l-1.53288,0.00847c-0.34278,0.00223-0.6186,0.28134-0.61713,0.62371l0.04632,8.31936   c0.00151,0.34237,0.281,0.61857,0.62378,0.61675l1.53285-0.00847c0.7554-0.00405,1.39828-0.45602,1.68658-1.09667l6.57206,3.24113   c1.2188,0.60095,2.67077,0.5932,3.8822-0.0217l4.42575-2.24337C19.62783,23.72215,20.04491,22.6699,19.63229,21.75233z    M2.19555,23.03696l-0.9128,0.00514l-0.03902-7.07958l0.91356-0.00514c0.34203-0.00147,0.6208,0.27397,0.62299,0.61675   l0.0324,5.83946C2.81416,22.75596,2.5383,23.03477,2.19555,23.03696z M18.20902,23.05019l-4.42579,2.24378   c-0.8657,0.43909-1.90282,0.44464-2.77297,0.01505l-6.96044-3.43237l-0.0287-5.19624l1.50933-0.40748   c1.50199-0.40494,3.08119,0.37402,3.6748,1.812c0.34861,0.84732,0.68183,1.13936,1.08197,1.33646l2.91714,1.43874   c0.30675,0.15113,0.43326,0.5237,0.28172,0.83007c-0.15151,0.30668-0.5237,0.43319-0.83042,0.28206l-2.84065-1.40082   c-0.30675-0.15116-0.67891-0.02506-0.83045,0.28206c-0.15151,0.30706-0.02499,0.67888,0.28244,0.83042l3.21288,1.58434   c0.46117,0.22765,1.00177,0.2534,1.48283,0.07063l3.74464-1.4207c0.34278-0.12984,0.67596,0.05955,0.79586,0.34755   C18.62825,22.56732,18.48923,22.9086,18.20902,23.05019z"
                                                        />
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="_desc_p8fps_10">ฝากได้เลยตอนนี้!</div>
                                    <div className="_subDesc_p8fps_15" />
                                </div>
                            </div>
                        </section>
                    </div>

                    <div className="mobile-register-content">

                        <div className="registration-title">
                            สมัครสมาชิก
                        </div>

                        <form
                            className="standard-form-container"
                            autoComplete="new-password"
                            onSubmit={(e) => this.nextstep(e, 25)}
                        >

                            <div className="register-input-container">
                                <div className="standard-form-field username-field">

                                    <label className="standard-label standard-mandatory standard-form-col-100">
                                        ยูสเซอร์เนม
                                    </label>

                                    <div className="standard-form-field-wrapper">
                                        <input
                                            type="text"
                                            id="phoneNumber"
                                            name="phoneNumber"
                                            className="standard-input standard-form-col-100"
                                            placeholder="กรอกเบอร์โทรศัพท์"
                                            value={phoneNumber || ""}
                                            maxLength={10}
                                            onChange={this.onChangex}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="register-input-container">
                                <div className="standard-form-field password-field">

                                    <label className="standard-label standard-mandatory standard-form-col-100">
                                        รหัสผ่าน
                                    </label>

                                    <div className="standard-form-field-wrapper password-field">

                                        <input
                                            type={showpass ? "password" : "text"}
                                            id="password"
                                            name="password"
                                            className="standard-input standard-form-col-100"
                                            autoComplete="new-password"
                                            placeholder="กรอกรหัสผ่าน"
                                            value={password || ""}
                                            onChange={this.onChangex}
                                        />

                                        <svg
                                            onClick={this.changepass}
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 1024 1024"
                                            className="standard-password-eye"
                                            width="1em"
                                            height="1em"
                                        >
                                            <g className="AiOutlineEyeInvisible">
                                                <path d="M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z" />
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div className="register-input-container">
                                <div className="standard-form-field password-field">

                                    <label className="standard-label standard-mandatory standard-form-col-100">
                                        ยืนยันรหัสผ่าน
                                    </label>

                                    <div className="standard-form-field-wrapper password-field">

                                        <input
                                            type={showpass ? "password" : "text"}
                                            id="passwordcf"
                                            name="passwordcf"
                                            className="standard-input standard-form-col-100"
                                            autoComplete="new-password"
                                            placeholder="ยืนยันรหัสผ่าน"
                                            value={passwordcf || ""}
                                            onChange={this.onChangex}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="register-input-container">

                                <div className="standard-form-field phone-field">

                                    <label className="standard-label standard-mandatory standard-form-col-100">
                                        เบอร์ติดต่อ
                                    </label>

                                    <div className="standard-form-field-wrapper">

                                        <input
                                            type="text"
                                            name="phoneNumber"
                                            className="standard-input standard-form-col-100"
                                            placeholder="กรอกเบอร์โทรศัพท์"
                                            value={phoneNumber || ""}
                                            maxLength={10}
                                            onChange={this.onChangex}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="register-input-container">

                                <div className="standard-form-field preferredCurrencyLabel-field">

                                    <label className="standard-label standard-mandatory standard-form-col-100">
                                        ธนาคาร
                                    </label>

                                    <div className="register-bank-grid mobile-register-bank-grid">

                                        {Array.isArray(tblbank) && tblbank.length > 0 ? (
                                            tblbank.map((listitem, i) => (
                                                <button
                                                    key={`${listitem.bank_id}-${i}`}
                                                    type="button"
                                                    className={`register-bank-item ${bankselect === listitem.bank_id ? "active" : ""}`}
                                                    onClick={() => this.radiocheck(listitem.bank_id)}
                                                >
                                                    <img
                                                        className={
                                                            bankselect !== listitem.bank_id
                                                                ? "imgBank"
                                                                : "imgBankNotSelect"
                                                        }
                                                        src={listitem.img_path}
                                                        alt={listitem.bank_name || "bank"}
                                                    />
                                                </button>
                                            ))
                                        ) : (
                                            <div className="register-bank-loading">
                                                กำลังโหลดธนาคาร...
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="register-input-container">

                                <div className="standard-form-field fullname-field">

                                    <label className="standard-label standard-mandatory standard-form-col-100">
                                        เลขบัญชีธนาคาร
                                    </label>

                                    <div className="standard-form-field-wrapper">

                                        <input
                                            type="text"
                                            id="accnumbertxt"
                                            name="accnumbertxt"
                                            className="standard-input standard-form-col-100"
                                            placeholder="เลขบัญชีธนาคาร"
                                            value={accnumbertxt || ""}
                                            onChange={this.onChangex}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* ชื่อ-นามสกุล — ย้ายมาไว้ใต้เลขบัญชี พร้อมพื้นหลังเทา */}
                            <div className="register-input-container" style={{ background: '#f3f4f6', borderRadius: 8, padding: '12px 16px', marginBottom: 8 }}>
                                <div className="standard-form-field fullname-field">
                                    <label className="standard-label standard-form-col-100" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                        ชื่อ-นามสกุล
                                        <span
                                            title="ไม่ต้องกรอกชื่อ ให้ใส่แค่เลขบัญชีธนาคาร ระบบจะตรวจสอบชื่อให้อัตโนมัติ"
                                            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 18, height: 18, borderRadius: '50%', background: '#6b7280', color: '#fff', fontSize: 11, fontWeight: 700, cursor: 'default', flexShrink: 0 }}
                                        >?</span>
                                    </label>
                                    <div className="standard-form-field-wrapper">
                                        <input
                                            type="text"
                                            id="fname"
                                            name="fname"
                                            className="standard-input standard-form-col-100"
                                            placeholder="ชื่อบัญชีธนาคาร"
                                            value={fname || ""}
                                            onChange={this.onChangex}
                                            disabled={trueaccount}
                                        />
                                    </div>
                                    <div style={{ marginTop: 6, fontSize: 12, color: '#6b7280', display: 'flex', alignItems: 'center', gap: 4 }}>
                                        <span>ℹ️</span>
                                        <span>ไม่ต้องกรอก — ระบบจะตรวจสอบชื่อจากเลขบัญชีธนาคารให้อัตโนมัติ</span>
                                    </div>
                                </div>
                            </div>

                            <div className="register-input-container affiliateID">

                                <div className="standard-form-field affiliateid-field ignore-after">

                                    <label className="standard-label standard-form-col-100">
                                        ID พันธมิตร / รหัสแนะนำ
                                    </label>

                                    <div className="standard-form-field-wrapper aff-field">

                                        <input
                                            type="text"
                                            name="userrecomend"
                                            className="standard-input standard-form-col-100 afffield"
                                            placeholder="ถ้ามี"
                                            value={userrecomend || ""}
                                            onChange={this.onChangex}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="transaction-button-section">

                                <div className="standard-button-container reg-btn-container">

                                    <button
                                        className="standard-submit-form-button"
                                        disabled={loading}
                                        data-button-category="submit"
                                        type="submit"
                                    >
                                        <span>
                                            {loading ? "กำลังสมัครสมาชิก..." : "สมัครสมาชิก"}
                                        </span>
                                    </button>
                                </div>
                            </div>

                            <div className="reg-footer-notice">
                                ด้วยการคลิกที่ปุ่ม ลงทะเบียน, ข้าพเจ้าขอรับรองว่าข้าพเจ้ามีอายุเกิน 18 ปี
                            </div>

                        </form>
                    </div>

                    <style>
                        {`
                    .mobile-register-content{
                        padding:16px;
                    }

                    .mobile-register-bank-grid{
                        display:grid;
                        grid-template-columns:repeat(4,minmax(0,1fr));
                        gap:10px;
                        width:100%;
                    }

                    .register-bank-item{
                        border:1px solid rgba(255,255,255,.08);
                        background:#fff;
                        border-radius:12px;
                        min-height:52px;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        padding:8px;
                        cursor:pointer;
                        transition:all .18s ease;
                    }

                    .register-bank-item.active{
                        border-color:#0071e3;
                        box-shadow:0 0 0 2px rgba(0,113,227,.16);
                    }

                    .register-bank-item img{
                        width:34px;
                        height:34px;
                        object-fit:contain;
                    }

                    .register-bank-loading{
                        grid-column:1/-1;
                        font-size:13px;
                        color:#8697a2;
                        padding:10px 0;
                        text-align:center;
                    }

                    .standard-submit-form-button{
                        width:100%;
                    }
                    `}
                    </style>
                </div>
            </>
        );
    };

    // 
    forgetotpandregister = async (type) => {
        const {
            phoneNumber,
            otpphoneforget,
            bankselect,
            otpphone,
            accnumbertxt
        } = this.state;

        try {
            if (type === 4) {
                const res = await instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    System: Systems,
                    type: type
                });

                return res.data.message;
            }

            if (type === 5) {
                const res = await instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    pin: otpphoneforget,
                    System: Systems,
                    type: type
                });

                return res.data.message;
            }

            if (type === 6) {
                const res = await instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    System: Systems,
                    type: type
                });

                return res.data.message;
            }

            if (type === 7) {
                const res = await instance.post("/api/v1/resetpassword", {
                    username: phoneNumber,
                    pin: otpphone,
                    System: Systems,
                    type: type
                });

                return res.data.message;
            }

            if (type === 10) {
                const res = await instance.post("/api/v1/resetpassword", {
                    accountnumber: accnumbertxt,
                    bankid: bankselect,
                    System: Systems,
                    type: type
                });

                return res.data.message;
            }

            return false;
        } catch (error) {
            console.log("[FORGET_OTP_REGISTER_ERROR]", error);
            return false;
        }
    };

    nextstep = async (e, num) => {
        if (e) e.preventDefault();

        if (this.state.loading) return false;

        const {
            password,
            bankselect,
            passwordcf,
            phoneNumber,
            fname,
            otpphone,
            accnumbertxt
        } = this.state;

        if (num === 1) {
            const phone = String(phoneNumber || "").trim();

            if (phone.length !== 10) {
                await this.notify("warning", "คุณใส่เบอร์ผิดพลาด");
                return false;
            }

            this.setState({ loading: true });

            const check = await this.forgetotpandregister(6);

            this.setState({ loading: false });

            if (check && check.checked) {
                this.setState({
                    stateregis: 2
                });
                return true;
            }

            if (check && check.status === 201) {
                await this.notify("warning", "เบอร์นี้มีคนใช้แล้ว");
                return false;
            }

            await this.notify("warning", "คุณทำรายการถี่เกินไป โปรดรอซักครู่");
            this.setState({
                stateopterror: "คุณทำรายการถี่เกินไป โปรดรอซักครู่"
            });
            return false;
        }

        if (num === 2) {
            if (!password || String(password).length < 6) {
                await this.notify("warning", "รหัสผ่านต้องมีอย่างน้อย 6 ตัว");
                return false;
            }

            if (String(password).length > 15) {
                await this.notify("warning", "รหัสผ่านสูงสุดไม่เกิน 15 ตัว");
                return false;
            }

            if (password !== passwordcf) {
                await this.notify("warning", "คุณใส่พาสเวิร์ดไม่ตรงกัน");
                return false;
            }

            this.setState({
                stateregis: 3
            });

            return true;
        }

        if (num === 5) {
            const check = await this.forgetotpandregister(7);

            if (otpphone !== "" && check && check.checked) {
                this.setState({
                    stateregis: 2
                });
                return true;
            }

            if (otpphone === "" || String(otpphone).length < 4) {
                await this.notify("warning", "คุณใส่ตัวเลขไม่ครบ");

                const otpEl = document.getElementById("otpphone");
                const checkEl = document.getElementById("checkotp");

                if (otpEl) otpEl.style = "border-color: #ef4444;";
                if (checkEl) checkEl.style.display = "block";

                return false;
            }

            await this.notify("warning", "รหัสผิดพลาด");

            const otpEl = document.getElementById("otpphone");
            const checkEl = document.getElementById("checkotp");

            if (otpEl) otpEl.style = "border-color: #ef4444;";
            if (checkEl) checkEl.style.display = "block";

            return false;
        }

        if (num === 11) {
            this.setState({
                stateregis: 1
            });
            return true;
        }

        if (num === 22) {
            this.setState({
                stateregis: 2
            });
            return true;
        }

        if (num === 25) {
            if (!accnumbertxt) {
                await this.modalerror({
                    title: "error",
                    text: "คุณไม่ทำการใส่เลขบัญชีธนาคาร"
                });
                return false;
            }

            if (String(accnumbertxt).length < 10) {
                await this.modalerror({
                    title: "error",
                    text: "เลขบัญชีธนาคารไม่ถูกต้อง"
                });
                return false;
            }

            if (!bankselect || Number(bankselect) === 0) {
                await this.modalerror({
                    title: "error",
                    text: "คุณยังไม่ได้เลือกธนาคาร"
                });
                return false;
            }

            this.setState({
                loading: true
            });

            try {
                if (!fname) {
                    const check = await this.forgetotpandregister(10);

                    if (check && check.checked && check.verifications) {
                        if (Number(check.verifications.status) === 0) {
                            this.setState({
                                trueaccount: false,
                                loading: false
                            });

                            await this.notify("warning", "กรุณากรอกชื่อบัญชีให้ตรงกับเลขบัญชี");
                            return false;
                        }

                        if (Number(check.verifications.status) === 1) {
                            this.setState({
                                fname: check.verifications.name
                            });

                            await this.validatergisterForm(e, check.verifications.name);
                            return true;
                        }
                    }

                    await this.modalerror({
                        title: "error",
                        text: "เลขบัญชีไม่ถูกต้อง"
                    });
                    return false;
                }

                await this.validatergisterForm(e, fname);
                return true;
            } finally {
                this.setState({
                    loading: false
                });
            }
        }

        return false;
    };

    modalerror = async (object) => {
        await this.notify(object.title, object.text);
    };

    validatergisterForm = async (e, fname) => {
        if (e) e.preventDefault();

        const {
            phoneNumber,
            password,
            passwordcf,
            bankselect,
            accnumbertxt,
            userrecomend
        } = this.state;

        if (!phoneNumber || String(phoneNumber).length !== 10) {
            await this.modalerror({
                title: "error",
                text: "คุณใส่เบอร์ผิดพลาด"
            });
            return false;
        }

        if (!accnumbertxt) {
            await this.modalerror({
                title: "error",
                text: "คุณไม่ทำการใส่เลขบัญชีธนาคาร"
            });
            return false;
        }

        if (!fname) {
            await this.modalerror({
                title: "error",
                text: "คุณไม่ทำการใส่ ชื่อ-นามสกุล"
            });
            return false;
        }

        if (!bankselect || Number(bankselect) === 0) {
            await this.modalerror({
                title: "error",
                text: "คุณยังไม่ได้เลือกธนาคาร"
            });
            return false;
        }

        if (!password || String(password).length < 6) {
            await this.modalerror({
                title: "error",
                text: "พาสเวิร์ดขั้นต่ำ 6 ตัว"
            });
            return false;
        }

        if (String(password).length > 15) {
            await this.modalerror({
                title: "error",
                text: "พาสเวิร์ดสูงสุดไม่เกิน 15 ตัว"
            });
            return false;
        }

        if (password !== passwordcf) {
            await this.modalerror({
                title: "error",
                text: "รหัสยืนยันไม่ตรงกัน"
            });
            return false;
        }

        try {
            const res = await instance.post("/api/v1/register", {
                User_id: phoneNumber,
                name: fname,
                password: password,
                accbank: bankselect,
                accno: accnumbertxt,
                System: Systems,
                Useradvise: userrecomend
            });

            if (res.data.status === 200) {
                await this.modalerror({
                    title: "success",
                    text: "ทำการสมัครเรียบร้อย กรุณารอสักครู่"
                });

                const loginRes = await instance.post("/api/v1/userlogin", {
                    userid: phoneNumber,
                    password: password,
                    System: Systems,
                    Function: "validateLoginForm-navbar.js"
                });

                if (loginRes.status === 200 && loginRes.data.status === 200) {
                    localStorage.setItem("auth_token", loginRes.data.token);

                    setTimeout(() => {
                        window.location.href = "/";
                    }, 1500);
                }

                return true;
            }

            if (res.data.status === 203) {
                await this.modalerror({
                    title: "error",
                    text: "เลขบัญชี นี้ทำการสมัครไปแล้ว"
                });
                return false;
            }

            if (res.data.status === 202) {
                await this.modalerror({
                    title: "error",
                    text: "Username นี้ทำการสมัครไปแล้ว"
                });
                return false;
            }

            await this.modalerror({
                title: "error",
                text: res.data.message || "Username หรือ ชื่อในการสมัครไม่ถูกต้อง"
            });

            return false;
        } catch (error) {
            console.log("[REGISTER_ERROR]", error);

            await this.modalerror({
                title: "error",
                text: "สมัครสมาชิกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"
            });

            return false;
        }
    };

    changepass = (e) => {
        if (e) e.preventDefault();

        this.setState({
            showpass: !this.state.showpass
        });
    };

    saveclickaff = async (linkid) => {
        try {
            const res = await instance.post("/api/v1/saveclickaff", {
                linkid: linkid,
                System: Systems
            });

            if (res.data.status === 200) {
                const date = new Date();
                const username = res.data.username;

                this.setState({
                    userrecomend: username,
                    link: linkid
                });

                localStorage.setItem("aff", JSON.stringify({
                    date,
                    username
                }));
            }
        } catch (error) {
            console.log("[SAVE_CLICK_AFF_ERROR]", error);
        }
    };

    saveclick = async (linkid) => {
        try {
            const res = await instance.post("/api/v1/saveclickaff", {
                linkid: linkid,
                System: Systems
            });

            if (res.data.status === 200) {
                const date = new Date();
                const username = res.data.username;

                this.setState({
                    userrecomend: username
                });

                localStorage.setItem("aff", JSON.stringify({
                    date,
                    username
                }));
            }
        } catch (error) {
            console.log("[SAVE_CLICK_ERROR]", error);
        }
    };

    componentDidUpdate(prevProps) {
        const { userrecomend } = this.props;

        if (prevProps.userrecomend !== userrecomend) {
            if (userrecomend !== this.state.userrecomend) {
                this.setState({
                    userrecomend
                });
            }
        }
    }

    componentDidMount = async () => {
        const search = window.location.href;

        const affParam = search.split("aff=")[1];
        if (affParam !== undefined) {
            await this.saveclickaff(affParam.split("&")[0]);
        }

        const regParam = search.split("reg=")[1];
        if (regParam !== undefined) {
            const regCode = regParam.split("&")[0];

            await this.saveclick(regCode);

            this.setState({
                userrecomend: regCode
            });
        }

        const tokenf = localStorage.getItem("aff");
        if (tokenf !== null) {
            try {
                const codev = JSON.parse(tokenf);

                this.setState({
                    userrecomend: codev.username || ""
                });
            } catch (error) {
                localStorage.removeItem("aff");
            }
        }

        const tokenx = localStorage.getItem("register");
        if (tokenx !== null) {
            try {
                const codev = JSON.parse(tokenx);

                this.setState({
                    userrecomend: codev.username || ""
                });
            } catch (error) {
                localStorage.removeItem("register");
            }
        }

        try {
            const res = await instance.post("/api/v1/mainsetting", {
                System: Systems
            });

            if (res.data.status === 200) {
                const datas = res.data.message || [];
                const tblcatagoryx = res.data.tblcatagoryx || [];
                const tblsetting = res.data.tblsetting || [];
                const tblbank = Array.isArray(res.data.tblbank) ? res.data.tblbank : [];

                const min = tblcatagoryx?.[0]?.limitdeposit || 0;
                const max = tblcatagoryx?.[0]?.maxdeposit || 0;

                this.setState({
                    mainsetting: datas,
                    linelink: datas?.[1]?.value || "",
                    tblbank: tblbank,
                    logoimg: tblsetting?.[0]?.imglogo || "",
                    System: tblcatagoryx?.[0]?.System || Systems,
                    limit: {
                        min,
                        max
                    }
                });
            }
        } catch (error) {
            console.log("[REGISTER_MAINSETTING_ERROR]", error);

            this.setState({
                tblbank: [],
                logoimg: "",
                limit: {
                    min: 0,
                    max: 0
                }
            });
        }
    };


    render() {
        const isMobilePage = this.props.page === "mobile";

        return isMobilePage ? this.renderMobile() : this.renderDesktop();
    }
}
export default App;
